import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useBackToTop } from "@/hooks/useSmoothScroll";

interface BackToTopProps {
  threshold?: number;
  className?: string;
}

const BackToTop: React.FC<BackToTopProps> = ({ 
  threshold = 500, 
  className = "" 
}) => {
  const { showButton, scrollToTop } = useBackToTop(threshold);

  if (!showButton) return null;

  return (
    <Button
      onClick={scrollToTop}
      size="lg"
      variant="fs-primary"
      className={`fixed bottom-8 left-8 z-40 w-14 h-14 rounded-full shadow-lg shadow-fs-purple-500/25 hover:shadow-xl hover:shadow-fs-purple-500/40 transition-all duration-300 hover:scale-110 animate-fade-in ${className}`}
      aria-label="Voltar ao topo"
    >
      <ArrowUp className="w-6 h-6" />
    </Button>
  );
};

export default BackToTop;